<template>
  <div class="content-block">
    <div class="row">
      <div class="col-md-7">
        <div class="dep-edit-block">
          <div class="edit-user-block__title">
            {{ $t('orgs.subdivision_note') }}
          </div>
          <template v-if="!collapseVisible.description && org.getDescription()">
            <div class="edit-user-block__data-row-value edit-user__description" v-html="org.getDescription()"></div>
          </template>
          <template v-if="!collapseVisible.description && !org.getDescription()" class="edit-user-block__data-row-value">
            <div class="edit-user-block__data-row-value">
              {{ $t('labels.not_specified1') }}
            </div>
          </template>
          <div class="edit-user-block__collapse-link" v-if="!collapseVisible.description">
            <span @click="collapseVisible.description = !collapseVisible.description, showCurrentData()"
                  >
                  {{ $t('labels.change') }}
            </span>
          </div>
          <div v-if="collapseVisible.description" class="edit-user-block__collapse-item">
            <el-input v-bind:class="{ showLabel: description }"
                      class="edit-user-block__input"
                      type="textarea"
                      :placeholder="$t('orgs.subdivision_note')"
                      v-model="description">
              <label slot="prefix">{{ $t('orgs.subdivision_note') }}</label>
            </el-input>
            <el-button @click="setDescription" type="primary">{{ $t('labels.save') }}</el-button>
            <el-button @click="collapseVisible.description = !collapseVisible.description">{{ $t('labels.cancel') }}</el-button>
          </div>
        </div>

        <div class="dep-edit-block">
          <div class="edit-user-block__title">
            {{ $t('labels.address') }}
          </div>
          <template v-if="!collapseVisible.address && org.getAddress()">
            <div class="edit-user-block__data-row-value">
              {{org.getAddress()}}
            </div>
          </template>
          <template v-if="!collapseVisible.contacts && !org.getAddress()" class="edit-user-block__data-row-value">
            <div class="edit-user-block__data-row-value">
              {{ $t('labels.not_specified3') }}
            </div>
          </template>
          <div class="edit-user-block__collapse-link" v-if="!collapseVisible.address">
            <span @click="collapseVisible.address = !collapseVisible.address, showCurrentData()"
                  >
                  {{ $t('labels.change') }}
            </span>
          </div>
          <div v-if="collapseVisible.address" class="edit-user-block__collapse-item">
            <el-input v-bind:class="{ showLabel: address || error.address.invalid, error: error.address.invalid}"
                      class="edit-user-block__input"
                      :placeholder="$t('orgs.address_org')"
                      v-model="address">
              <label v-if="error.address.invalid"
                     class="label-error"
                     slot="prefix">
                      {{ error.address.message }}
              </label>
              <label v-else slot="prefix">{{ $t('orgs.address_org') }}</label>
            </el-input>
            <el-button @click="setAddress" type="primary">{{ $t('labels.save') }}</el-button>
            <el-button @click="collapseVisible.address = !collapseVisible.address, coords = null, resetError()">{{ $t('labels.cancel') }}</el-button>
          </div>
      </div>

        <div class="dep-edit-block">
          <div class="edit-user-block__title">
            {{ $t('labels.contacts') }}
          </div>
          <template v-if="!collapseVisible.contacts && org.getContacts().length">
            <div class="edit-user-block__data-row" v-for="(contact, index) in org.getContacts()" :key="index">
              <div class="edit-user-block__data-row-label">
                {{ contact.type }}
              </div>
              <div class="edit-user-block__data-row-value">
                {{ contact.value }}
              </div>
            </div>
          </template>
          <div v-else class="edit-user-block__data-row-value">
            {{ $t('labels.not_specified2') }}
          </div>
          <div class="edit-user-block__collapse-link" v-if="!collapseVisible.contacts">
            <span @click="collapseVisible.contacts = !collapseVisible.contacts, showCurrentData()"
                  >
                  {{ $t('labels.change') }}
            </span>
          </div>
          <div v-if="collapseVisible.contacts" class="edit-user-block__collapse-item">
            <div class="dep-edit-another-contacts">
              <div class="dep-edit-another-contacts__block" v-for="(phone, index) in contacts" :key="index">
                <div class="dep-edit-another-contacts__row">
                  <el-input v-bind:class="{ showLabel: contacts[index].type || error.another.invalid, error: error.another.invalid && !contacts[index].type }"
                            :placeholder="$t('labels.title')"
                            class="dep-edit-block__input"
                            v-model="contacts[index].type"
                            @input="resetError">
                      <label v-if="error.another.invalid && !contacts[index].type"
                        class="label-error"
                        slot="prefix">
                        {{ error.another.message }}
                      </label>
                     <label v-else
                       slot="prefix">{{ $t('labels.title') }}</label>
                  </el-input>
                  <el-input v-bind:class="{ showLabel: contacts[index].value || error.another.invalid, error: error.another.invalid && !contacts[index].value }"
                            :placeholder="$t('labels.contacts')"
                            class="dep-edit-block__input"
                            v-model="contacts[index].value"
                            @input="resetError">
                      <label v-if="error.another.invalid && !contacts[index].value"
                        class="label-error"
                        slot="prefix">
                        {{ error.another.message }}
                      </label>
                     <label v-else
                       slot="prefix">{{ $t('labels.contact') }}</label>
                  </el-input>
                  <img class="dep-create-another-contacts__delete" @click="deleteAnotherContact(index)" :title="$t('labels.delete')"
                       src="static/img/icon_dropmenu_trash.svg"/>
                  </div>
                </div>
              <div class="dep-edit-another-contacts__add">
                <span @click="addAnotherContact">
                  {{ $t('labels.add') }}
                </span>
              </div>
            </div>
            <el-button @click="setContacts" type="primary">{{ $t('labels.save') }}</el-button>
            <el-button @click="collapseVisible.contacts = false">{{ $t('labels.cancel') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import lodash from 'lodash'
  // import org from 'src/api/org'
  import MaskedInput from 'vue-masked-input'
  export default {
    props: {
      org: {
        type: Object,
        default () { return {} }
      }
    },
    components: {
      MaskedInput
    },
    data () {
      return {
        description: '',
        address: '',
        coords: null,
        contacts: [],
        mapLoading: true,
        collapseVisible: {
          description: false,
          address: false,
          contacts: false
        },
        error: {
          phones: {
            invalid: false,
            message: ''
          },
          another: {
            invalid: false,
            message: ''
          },
          address: {
            invalid: false,
            message: ''
          }
        }
      }
    },
    methods: {
      showCurrentData () {
        this.description = this.org.getDescription()
        this.address = this.org.getAddress();
        this.contacts = this.org.getContacts();
      },
      hideCollapse () {
        this.collapseVisible = {
          description: false,
          address: false,
          contacts: false
        }
      },
      async orgUpdate (field) {
        try {
          await this.$store.dispatch('orgs/updateOrg', {
            org_id: this.org.getId(),
            ...field
          })
          this.$emit('updateData')
          this.hideCollapse()
        } catch (e) {
          this.$emit('error')
        }
      },
      setError (key, message) {
        this.error[key].invalid = true;
        this.error[key].message = message;
      },
      resetError () {
        this.error = {
          phones: {
            invalid: false,
            message: ''
          },
          another: {
            invalid: false,
            message: ''
          },
          address: {
            invalid: false,
            message: ''
          }
        }
      },
      addAnotherContact () {
        this.contacts.push({
          value: '',
          type: ''
        })
      },
      deleteAnotherContact (index) {
        this.contacts.splice(index, 1);
      },
      validateAddress () {
        if (!this.address) {
          this.setError('address', this.$t('labels.required_field'))
        } else {
          return true;
        }
      },
      validateAnotherContacts () {
        for (let contact of this.contacts) {
          if (!contact.type || !contact.value) {
            this.setError('another', this.$t('labels.required_field'))
          }
        }

        if (this.error.another.invalid) {
          return false;
        } else {
          return true;
        }
      },
      setDescription () {
        let data = {
          description: this.description
        }
        this.orgUpdate(data);
      },
      setAddress () {
        if (this.validateAddress()) {
          let data = {
            address: this.address
          }
          this.orgUpdate(data);
        }
      },
      setContacts () {
        if (this.validateAnotherContacts()) {
          let data = {
            contacts: this.contacts
          }
          this.orgUpdate(data);
        }
      },
    },
    mounted () {
      this.showCurrentData()
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.edit-user__description{white-space: pre-line;}
.dep-edit-phones, .dep-edit-another-contacts {
  margin-bottom: 25px;

  .el-input {
    margin-bottom: 0 !important;
  }

  &__block {
    position: relative;
  }

  &__row {
    display: grid;
    grid-template-columns: .5fr 1fr 20px;
    align-items: center;
    grid-column-gap: 15px;
    margin-bottom: 25px;

    @media (max-width: $screen-sm){
      grid-template-columns: 1fr;
    }
  }

  &__add {
    // margin-top: -20px;
    color: #2196F3;
    cursor: pointer;

    &:hover {
      color: lighten(#2196F3, 15%);
    }
  }

  &__delete {
    margin-bottom: 25px;
    margin-top: -28px;
    span {
      font-size: 12px;
      color: #2196F3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196F3, 15%);
      }
    }
  }

  &__error {
    position: absolute;
    left: 10px;
    top: -20px;
    color: #ff5151;
  }
}

.dep-edit-map {
  margin-bottom: 15px;
}
</style>
